var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.l_visible
        ? _c("v-autocomplete", {
            ref: "control",
            staticClass: "dynamic-input-control",
            class: {
              validated:
                _vm.displayValidated && !_vm.hasError && !_vm.errorMessages,
              required: _vm.l_required,
              readonly: _vm.readonly
            },
            attrs: {
              errorMessages: _vm.errorMessages,
              value: _vm.idDodavatela,
              outlined: "",
              items: _vm.items,
              loading: _vm.isLoading,
              "hide-no-data": "",
              label: _vm.l_label,
              "append-icon": _vm.isDisabled ? "" : "mdi-chevron-down",
              "search-input": _vm.search,
              disabled: _vm.isDisabled,
              rules: _vm.getRules,
              placeholder: _vm.placeholder,
              "return-object": "",
              readonly: _vm.isLoading || _vm.isDisabled,
              "item-text": "display_member",
              "item-value": "value_member"
            },
            on: {
              input: function(newVal) {
                _vm.setDirty(true)
                _vm.update(newVal)
              },
              "update:searchInput": function($event) {
                _vm.search = $event
              },
              "update:search-input": function($event) {
                _vm.search = $event
              },
              focusout: _vm.focusout
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "append",
                  fn: function() {
                    return [
                      !_vm.isDisabled
                        ? _c(
                            "div",
                            {
                              staticClass: "v-input__icon v-input__icon--append"
                            },
                            [_c("v-icon", [_vm._v("mdi-chevron-down")])],
                            1
                          )
                        : _vm._e(),
                      !!_vm.getTooltip
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "350" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass:
                                                "btn-help text-body-2 ml-2",
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-help-circle")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1426974712
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.getTooltip) + " ")
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1090962514
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }